module.exports = __webpack_public_path__ + "img/horizontal_6_6_pp13_5.19015b57.png";